<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="[{ formCtrl }]"
      :viewMode="viewMode">
    </MyForm>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'hirecar',
      breadcrumb: [
        { name: "承运管理", path: `/carrier/hirecar` },
        { name: "外协车辆", path: `/carrier/hirecar` },
        { name: "车辆添加" },
      ],
      form: {},
      rules: {
        license: [
          {
            required: true,
            validator: this.checkLicense,
            trigger: 'blur',
          }
        ],
        company: [
          {
            required: true,
            message: '请填写所属承运公司',
            trigger: 'blur',
          }
        ],
        pcusid: [
          {
            required: true,
            message: '请选择所属承运公司',
            trigger: 'blur',
          }
        ],
        driver: [
          {
            required: true,
            message: '请填写司机姓名',
            trigger: 'blur',
          }
        ],
        phone: [
          {
            required: true,
            validator: this.checkPhone,
            trigger: 'blur',
          },
        ],
      },
      formCtrl: [
        {
          label: "所属承运公司",
          keyName: "company",
          err: "请选择所属承运公司",
          type: "select",
          options: [],
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
        },
        {
          label: "挂车号",
          keyName: "trailer",
          err: "请填写挂车号",
          type: "text",
        },
        {
          label: "车辆类型",
          keyName: "vtype",
          type: "select",
          options: []
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "phone",
          err: "请填写联系电话",
          type: "text",
        },
        {
          label: "核定载重(吨)",
          keyName: "ton",
          err: "请填写核定载重",
          type: "number",
        },
        {
          label: "车辆照片",
          keyName: "car_image",
          type: "file",
          ptype: "car",
          tips: "最多上传10张图片",
          max: 10,
        },
      ],
      pcustom: [],
    };
  },
  methods: {
    getKeys() {
      const arr = [
        'car_image',
        'driver',
        'id',
        'license',
        'pcusid',
        'phone',
        'ton',
        'trailer',
        'userid',
        'vtype',
      ]
      return arr
    },
    specialParamsPackage(params) {
      if (this.form['company'] && this.pcustom) {
        this.pcustom.map(v => {
          if (v.company === this.form['company']) {
            params['pcusid'] = v.id
          }
        })
      }
      if (!params['pcusid']) {
        params['pcusid'] = this.detail['pcusid']
      }
      // console.log('params', { ...params })
    },
    setOptions({ pcustom, car_type }) {
      this.formCtrl.map(v => {
        if (v.keyName == 'company' && pcustom && pcustom.length) {
          this.pcustom = [...pcustom]
          v.options = pcustom.map(val => {
            return {
              label: val.company,
              value: val.company,
            }
          })
        } else if (v.keyName == 'vtype' && car_type && car_type.length) {
          v.options = car_type.map(val => {
            return {
              label: val.name,
              value: val.name,
            }
          })
        }
      })
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
